// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1qJGJ","unreadBadge":"styles_unreadBadge__1lHoZ","modalContent":"styles_modalContent__QFrJO","modal":"styles_modal__1t0T4"};